import React from "react";
import { useParams } from "react-router";
import Breadcrumbs from "../../../../shared/breadcrumb/breadCrumb";
import AddTrainingPathForm from "./addTrainingPathForm";
import { translate } from "react-switch-lang";

const AddTrainingPath: React.FC<{ t: (key: string) => {} }> = props => {
  const params = useParams<{ id: string }>();
  return (
    <div>
      <Breadcrumbs parent={props.t("training_path_list")} title={params.id === undefined ? props.t("create_training_path") : props.t("update_training_path")} />
      <AddTrainingPathForm />
    </div>
  );
};

export default translate(AddTrainingPath);
